export interface Question {
  id: string;
  category: 'empathy' | 'growth' | 'adaptability' | 'purpose';
  text: string;
  type: 'likert';
}

export const surveyQuestions: Question[] = [
  // Empathy Questions (15 questions)
  {
    id: 'emp_1',
    category: 'empathy',
    text: 'I actively seek to understand the perspectives and feelings of my colleagues before making decisions.',
    type: 'likert'
  },
  {
    id: 'emp_2',
    category: 'empathy',
    text: 'I feel comfortable expressing my emotions and vulnerabilities at work.',
    type: 'likert'
  },
  {
    id: 'emp_3',
    category: 'empathy',
    text: 'My team members regularly check in on each other\'s well-being.',
    type: 'likert'
  },
  {
    id: 'emp_4',
    category: 'empathy',
    text: 'I notice when colleagues are struggling and offer support without being asked.',
    type: 'likert'
  },
  {
    id: 'emp_5',
    category: 'empathy',
    text: 'Our workplace culture encourages open discussion about personal challenges.',
    type: 'likert'
  },
  {
    id: 'emp_6',
    category: 'empathy',
    text: 'I feel heard and understood by my manager and peers.',
    type: 'likert'
  },
  {
    id: 'emp_7',
    category: 'empathy',
    text: 'Team meetings include time for personal updates and connection.',
    type: 'likert'
  },
  {
    id: 'emp_8',
    category: 'empathy',
    text: 'I can easily put myself in my colleagues\' shoes when conflicts arise.',
    type: 'likert'
  },
  {
    id: 'emp_9',
    category: 'empathy',
    text: 'Our organization provides resources for mental health and emotional support.',
    type: 'likert'
  },
  {
    id: 'emp_10',
    category: 'empathy',
    text: 'I feel safe being authentic and genuine in my workplace interactions.',
    type: 'likert'
  },
  {
    id: 'emp_11',
    category: 'empathy',
    text: 'My colleagues celebrate each other\'s personal milestones and achievements.',
    type: 'likert'
  },
  {
    id: 'emp_12',
    category: 'empathy',
    text: 'I actively listen to understand rather than to respond in conversations.',
    type: 'likert'
  },
  {
    id: 'emp_13',
    category: 'empathy',
    text: 'Our team has established psychological safety where everyone can speak up.',
    type: 'likert'
  },
  {
    id: 'emp_14',
    category: 'empathy',
    text: 'I consider the emotional impact of my decisions on team members.',
    type: 'likert'
  },
  {
    id: 'emp_15',
    category: 'empathy',
    text: 'We have regular one-on-one conversations that go beyond work tasks.',
    type: 'likert'
  },

  // Growth Mindset Questions (15 questions)
  {
    id: 'growth_1',
    category: 'growth',
    text: 'I view challenges as opportunities to learn and develop new skills.',
    type: 'likert'
  },
  {
    id: 'growth_2',
    category: 'growth',
    text: 'I actively seek feedback from others to improve my performance.',
    type: 'likert'
  },
  {
    id: 'growth_3',
    category: 'growth',
    text: 'Failure is treated as a learning opportunity rather than something to avoid.',
    type: 'likert'
  },
  {
    id: 'growth_4',
    category: 'growth',
    text: 'I dedicate time each week to developing new skills or knowledge.',
    type: 'likert'
  },
  {
    id: 'growth_5',
    category: 'growth',
    text: 'Our organization encourages experimentation and intelligent risk-taking.',
    type: 'likert'
  },
  {
    id: 'growth_6',
    category: 'growth',
    text: 'I feel excited about taking on projects outside my comfort zone.',
    type: 'likert'
  },
  {
    id: 'growth_7',
    category: 'growth',
    text: 'My manager supports my professional development goals.',
    type: 'likert'
  },
  {
    id: 'growth_8',
    category: 'growth',
    text: 'I regularly reflect on my work to identify areas for improvement.',
    type: 'likert'
  },
  {
    id: 'growth_9',
    category: 'growth',
    text: 'Our team celebrates learning from mistakes rather than avoiding them.',
    type: 'likert'
  },
  {
    id: 'growth_10',
    category: 'growth',
    text: 'I believe my abilities and intelligence can be developed through effort.',
    type: 'likert'
  },
  {
    id: 'growth_11',
    category: 'growth',
    text: 'I share knowledge and learnings openly with my colleagues.',
    type: 'likert'
  },
  {
    id: 'growth_12',
    category: 'growth',
    text: 'Our workplace provides ample opportunities for learning and development.',
    type: 'likert'
  },
  {
    id: 'growth_13',
    category: 'growth',
    text: 'I embrace constructive criticism as a path to improvement.',
    type: 'likert'
  },
  {
    id: 'growth_14',
    category: 'growth',
    text: 'I mentor others and learn from being mentored myself.',
    type: 'likert'
  },
  {
    id: 'growth_15',
    category: 'growth',
    text: 'Our culture rewards curiosity and continuous learning over just results.',
    type: 'likert'
  },

  // Adaptability Questions (15 questions)
  {
    id: 'adapt_1',
    category: 'adaptability',
    text: 'I feel comfortable with ambiguity and uncertainty in my work.',
    type: 'likert'
  },
  {
    id: 'adapt_2',
    category: 'adaptability',
    text: 'I quickly adjust my approach when circumstances change.',
    type: 'likert'
  },
  {
    id: 'adapt_3',
    category: 'adaptability',
    text: 'Our team effectively manages changing priorities and deadlines.',
    type: 'likert'
  },
  {
    id: 'adapt_4',
    category: 'adaptability',
    text: 'I see change as an opportunity rather than a threat.',
    type: 'likert'
  },
  {
    id: 'adapt_5',
    category: 'adaptability',
    text: 'Our organization communicates change clearly and transparently.',
    type: 'likert'
  },
  {
    id: 'adapt_6',
    category: 'adaptability',
    text: 'I can work effectively with different types of people and working styles.',
    type: 'likert'
  },
  {
    id: 'adapt_7',
    category: 'adaptability',
    text: 'We regularly review and adjust our processes to improve efficiency.',
    type: 'likert'
  },
  {
    id: 'adapt_8',
    category: 'adaptability',
    text: 'I remain calm and focused during periods of organizational change.',
    type: 'likert'
  },
  {
    id: 'adapt_9',
    category: 'adaptability',
    text: 'Our team is quick to pivot strategies when market conditions shift.',
    type: 'likert'
  },
  {
    id: 'adapt_10',
    category: 'adaptability',
    text: 'I actively contribute ideas for how we can improve and evolve.',
    type: 'likert'
  },
  {
    id: 'adapt_11',
    category: 'adaptability',
    text: 'I can switch between different projects and contexts efficiently.',
    type: 'likert'
  },
  {
    id: 'adapt_12',
    category: 'adaptability',
    text: 'Our culture supports innovation and trying new approaches.',
    type: 'likert'
  },
  {
    id: 'adapt_13',
    category: 'adaptability',
    text: 'I seek diverse perspectives when solving complex problems.',
    type: 'likert'
  },
  {
    id: 'adapt_14',
    category: 'adaptability',
    text: 'I feel equipped with the tools and resources to handle unexpected challenges.',
    type: 'likert'
  },
  {
    id: 'adapt_15',
    category: 'adaptability',
    text: 'Our organization learns and adapts quickly from external feedback.',
    type: 'likert'
  },

  // Purpose Questions (15 questions)
  {
    id: 'purpose_1',
    category: 'purpose',
    text: 'I understand how my daily work connects to the organization\'s mission.',
    type: 'likert'
  },
  {
    id: 'purpose_2',
    category: 'purpose',
    text: 'I feel energized and motivated by the impact of my work.',
    type: 'likert'
  },
  {
    id: 'purpose_3',
    category: 'purpose',
    text: 'Our organization\'s values align with my personal values.',
    type: 'likert'
  },
  {
    id: 'purpose_4',
    category: 'purpose',
    text: 'I can clearly articulate why our organization exists and what we stand for.',
    type: 'likert'
  },
  {
    id: 'purpose_5',
    category: 'purpose',
    text: 'My work contributes to something larger than myself.',
    type: 'likert'
  },
  {
    id: 'purpose_6',
    category: 'purpose',
    text: 'I feel proud to tell others where I work and what we do.',
    type: 'likert'
  },
  {
    id: 'purpose_7',
    category: 'purpose',
    text: 'Our organization makes decisions based on our stated values and purpose.',
    type: 'likert'
  },
  {
    id: 'purpose_8',
    category: 'purpose',
    text: 'I see clear connections between my role and positive outcomes for others.',
    type: 'likert'
  },
  {
    id: 'purpose_9',
    category: 'purpose',
    text: 'Leadership regularly communicates our mission and strategic direction.',
    type: 'likert'
  },
  {
    id: 'purpose_10',
    category: 'purpose',
    text: 'I feel my work has meaning beyond just earning a paycheck.',
    type: 'likert'
  },
  {
    id: 'purpose_11',
    category: 'purpose',
    text: 'Our organization actively contributes to the broader community.',
    type: 'likert'
  },
  {
    id: 'purpose_12',
    category: 'purpose',
    text: 'I can see how my individual contributions make a difference.',
    type: 'likert'
  },
  {
    id: 'purpose_13',
    category: 'purpose',
    text: 'We regularly celebrate achievements that advance our mission.',
    type: 'likert'
  },
  {
    id: 'purpose_14',
    category: 'purpose',
    text: 'I would recommend this organization to others based on our purpose and values.',
    type: 'likert'
  },
  {
    id: 'purpose_15',
    category: 'purpose',
    text: 'Our strategic decisions consistently reflect our organizational purpose.',
    type: 'likert'
  }
];

export const categoryInfo = {
  empathy: { name: 'Empathy', color: '#8b5cf6', description: 'Understanding and connecting with others' },
  growth: { name: 'Growth Mindset', color: '#10b981', description: 'Embracing learning and development' },
  adaptability: { name: 'Adaptability', color: '#06b6d4', description: 'Flexibility and change management' },
  purpose: { name: 'Purpose', color: '#f59e0b', description: 'Meaning and organizational mission' }
};